/**
 * Demo fixtures shared by the navigation pages.
 *
 * Lifted from the old single-file page, where they sat as module-level
 * constants above 22 section components.
 */

import React from 'react';
import { Heart, UserRound } from 'lucide-react';
import editionsImg from '@ajat/design-system/assets/overall/side-menu/editions.jpg';
import patchImg from '@ajat/design-system/assets/overall/side-menu/patch-universe.png';
import qualityImg from '@ajat/design-system/assets/overall/side-menu/quality.jpg';

// The demo links go nowhere — keep the dashboard URL
const stay = (e) => e.preventDefault();

/* SideMenu content (Figma OVER-LL 2388:6010) — the SideMenu page and the
   Overall Header demo (hamburger → SideMenu) share it */
export const DEMO_SIDE_MENU = {
  Overall: {
    title: 'Welcome',
    featured: { image: editionsImg, imageAlt: 'Overall with patches', label: 'DESIGNA EDITIONS', href: '#', onClick: stay },
    cards: [
      { image: patchImg, imageAlt: '', imageFit: 'contain', label: 'Patch Universe', href: '#', onClick: stay },
      { image: qualityImg, imageAlt: '', label: 'Quality', href: '#', onClick: stay },
    ],
    links: [
      { label: 'About Us', href: '#', onClick: stay },
      { label: 'Customer Service', href: '#', onClick: stay },
    ],
    actions: [
      { label: 'Mitt konto', icon: <UserRound size={16} strokeWidth={1.75} />, onClick: stay },
      { label: 'Mina designer', icon: <Heart size={16} strokeWidth={1.75} />, onClick: stay },
    ],
  },
};

export const DEMO_NAV_ITEMS = {
  CLS: [
    {
      label: 'STUDIETURTRØJE',
      href: '#',
      submenu: {
        watermark: 'Studieturtrøje',
        columns: [
          { type: 'card', cardType: 'button', image: require('../../../../assets/cls-dk/header/1.jpg'), imageAlt: 'Student trip hoodie', label: 'BESTIL STUDIETURTRØJER', href: '#' },
          { type: 'card', cardType: 'link', image: require('../../../../assets/cls-dk/header/2.jpg'), imageAlt: 'Create logotype', label: 'Create your logotype', href: '#' },
          { type: 'card', cardType: 'link', image: require('../../../../assets/cls-dk/header/3.jpg'), imageAlt: 'School shop', label: 'Open the School Shop', href: '#' },
          {
            type: 'links',
            items: [
              { label: 'Størrelses guide', href: '#' },
              { label: 'Tryk & Broderi', href: '#' },
              { label: 'Attraktive tøjpakker', href: '#' },
              { label: 'Om oss', href: '#' },
              { label: 'FAQ', href: '#' },
            ],
          },
        ],
      },
    },
    { label: 'STUDENTERUGENTRØJE', href: '#' },
    { label: 'STUDENTERHUE', href: '#' },
  ],
  ABC: [
    {
      label: 'Skolmerch',
      href: '#',
      submenu: {
        watermark: 'Skolmerch',
        columns: [
          { type: 'card', cardType: 'button', image: require('../../../../assets/abc-se/menu/menu-item-1.jpg'), imageAlt: 'Skolmerch collection', label: 'BUY SKOLMERCH', href: '#' },
          { type: 'card', cardType: 'link', image: require('../../../../assets/abc-se/menu/menu-item-2.jpg'), imageAlt: 'Size guide', label: 'Size Guide', href: '#' },
          {
            type: 'links',
            items: [
              { label: 'Customer Service', href: '#' },
              { label: 'Open School Shop', href: '#' },
              { label: 'About Us', href: '#' },
              { label: 'FAQ', href: '#' },
            ],
          },
        ],
      },
    },
    { label: 'Overalls & More', href: '#' },
    { label: 'Student Club', href: '#' },
    { label: 'Student Cap', href: '#' },
  ],
  // Figma Header/Clothing Brand=Overall (4150:4507) — plain links, no mega-menu yet
  Overall: [
    { label: 'OVERALLS', href: '#' },
    { label: 'PATCH UNIVERSE', href: '#' },
  ],
};

export const DEMO_MOBILE_PROMO = {
  CLS: {
    show: true,
    image: require('../../../../assets/cls-dk/header/1.jpg'),
    imageAlt: 'Student trip hoodie promo',
    label: 'BESTIL STUDIETURTRØJER',
    href: '#',
  },
  ABC: {
    show: true,
    image: require('../../../../assets/abc-se/menu/menu-item-1.jpg'),
    imageAlt: 'Skolmerch promo',
    label: 'BUY SKOLMERCH',
    href: '#',
  },
};
